// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5e0bcedd","584":"4fd1a0e6","619":"4ec67426","692":"413c94a5","871":"88862044","892":"56769282"}[chunkId] + ".chunk.js";
};